import React, { useEffect, useState } from "react";
import SubLayout from "../../components/layout/SubLayout";
import {
  Row,
  Col,
  Table,
  Button,
  Input,
  Dropdown,
  Radio,
  message,
  Tooltip,
  Modal,
  Upload,
} from "antd";
import EditIcon from "../../Assets/editIcon.svg";
import verticleDot from "../../Assets/dots-vertical.svg";
import DeleteImg from "../../Assets/campagin/delete.svg";
import SearchIcon from "../../Assets/campagin/searchIcon.svg";
import CancelIcon from "../../Assets/cancelIcon.svg";

import NoElementBox from "../../components/common/NoElementBox";
import FilterIcon from "../../Assets/filter.svg";
// import { JobActiveDeactivateModal } from "../../components/common/Popup";
import { Router, useLocation, useNavigate } from "react-router-dom";
import deleteIcon from "../../Assets/advert_detail/delete_icon_red.svg";
import CloneIcon from "../../Assets/advert_detail/cloneBox.svg";
import AdvertSummary from "../../components/common/AdvertDetail/AdvertSummary";
import status_image from "../../Assets/advert_detail/status.svg";
import downloadIcon from "../../Assets/advert_detail/download.svg";
import rocketIcon from "../../Assets/advert_detail/rocket.svg";
import externalRocket from "../../Assets/advert_detail/externalrel.png";
import exportImage from "../../Assets/advert_detail/exportImage.svg";
import {
  WorkforceTransferToolbarIcon,
  CandidateTransferBadges,
} from "../../components/common/AdvertDetail/WorkforceRequestButton";
import { TableStatusImage } from "../../Assets/campagin/sectionProgress/svgs";
import { CommonDeleteSvg } from "../../Assets/campagin/sectionProgress/svgs";
import checkFilled_image from "../../Assets/advert_detail/table-cell/check.svg";
import unCheckFilled_image from "../../Assets/advert_detail/table-cell/Tracker.svg";
import infoIcon from "../../Assets/advert_detail/infoIcon.svg";
import alert_triangle from "../../Assets/advert_detail/alert-triangle.svg";
import transeferImage from "../../Assets/advert_detail/transfer.svg";
import shareIcon from "../../Assets/shareIcon.svg";
import action_delete from "../../Assets/advert_detail/action-delete.svg";
import Reportpopup, {
  DeleteUserPopup,
  StatusModal,
  TransferModal,
  UpdateAlert,
  UpdatestatusPopup,
} from "../../components/common/AdvertDetail/Reportpopup";
import {
  DeleteAdvertModal,
  DeleteModal,
  ReleaseModal,
} from "../../components/common/Popup";
// import StatusModal from "../../components/common/AdvertDetail/StatusModal";
import NotificationPopup from "../../components/common/notificationPopup";
import UpgradeMembershipModal from "../../components/common/UpgradeMembershipPopup";
import BulkDelete from "./BulkDelete";
import API_MANAGER from "../../API";
// import rocketIcon from "../../../Assets/advert_detail/rocket.svg";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import CustomPagination from "../../components/common/CustomPagination";
import {
  downloadCsv,
  downloadPDF,
  numberWithCommas,
} from "../../utils/constant";
import MobileHeader from "../../components/layout/MobileHeader";
import ReleaseToExternalClientModal from "../../components/common/ExtrenalClient/ReleaseToExternalClientModal";
import ProfileDrawer from "./ProfileDrawer";
import TransferUserModal from "../../components/common/AdvertDetail/TransferUserModal";
import IncomingWorkforceRequestsModal from "../../components/common/AdvertDetail/IncomingWorkforceRequestsModal";

// Timer expiration constants and helpers for clearing preserved state
const ADVERT_STATE_EXPIRATION_MINUTES = 2;

// Helper function to check if stored state is expired
const isAdvertStateExpired = (timestamp) => {
  if (!timestamp) return true;
  const expirationTime = ADVERT_STATE_EXPIRATION_MINUTES * 60 * 1000; // 2 minutes in ms
  const currentTime = Date.now();
  return (currentTime - timestamp) > expirationTime;
};

// Helper function to save advert state with timestamp
const saveAdvertStateWithTimestamp = (advertId, key, value) => {
  try {
    const stateData = {
      value: value,
      timestamp: Date.now(),
    };
    sessionStorage.setItem(`${key}_${advertId}`, JSON.stringify(stateData));
  } catch (error) {
    console.error("Failed to save advert state to sessionStorage:", error);
  }
};

// Helper function to get advert state from sessionStorage (returns null if expired)
const getAdvertStateFromStorage = (advertId, key) => {
  try {
    const storedData = sessionStorage.getItem(`${key}_${advertId}`);
    if (!storedData) return null;
    
    // Try to parse as JSON with timestamp
    try {
      const parsedData = JSON.parse(storedData);
      
      // If it has timestamp structure, check expiration
      if (parsedData && typeof parsedData === 'object' && parsedData.timestamp !== undefined) {
        if (isAdvertStateExpired(parsedData.timestamp)) {
          // Expired - remove from storage
          sessionStorage.removeItem(`${key}_${advertId}`);
          return null;
        }
        let value = parsedData.value;
        // Defensive: unwrap any accidentally double-encoded {value, timestamp} string
        if (typeof value === 'string') {
          try {
            const inner = JSON.parse(value);
            if (inner && typeof inner === 'object' && inner.timestamp !== undefined && inner.value !== undefined) {
              value = inner.value;
            }
          } catch {
            // value is a plain string, keep as-is
          }
        }
        return value;
      }
      
      // Old format without timestamp - return as is but it will be overwritten with timestamp on next save
      return parsedData;
    } catch (parseError) {
      // Not JSON - could be old format string value
      return storedData;
    }
  } catch (error) {
    console.error("Failed to get advert state from sessionStorage:", error);
    return null;
  }
};

function AdvertDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isModalOpen, setisModalOpen] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [updatePopup, setUpdatePopup] = useState(false);
  const [transferModal, setTransferModal] = useState(false);
  const [transferUserModal, setTransferUserModal] = useState(false);
  const [updateAlert, setUpdateAlert] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [errorNotification, setErrorNotification] = useState(false);
  const [candidateSelectedData, setCandidateSelectedData] = useState({});
  const [upgradeMembership, setUpgradeMembership] = useState(false);
  const [bulkDeleteModal, setBulkDeleteModal] = useState(false);
  const [advertDetail, setAdvertDetail] = useState({});
  const [candidateDetails, setCandidatesDetails] = useState([]);
    const [filterDataAdvert, setfilterDataAdvert] = useState();
      const [advertIds, setadvertIds] = useState([]);
  const location = useLocation()
  console.log(candidateDetails,"CANDIDIATE DETAILS")
  const [sortType, setSortType] = useState("-createdAt");
  const [search, setSearch] = useState(() => {
    // Priority: location.state > sessionStorage with expiration check
    if (location.state?.search !== undefined) {
      return location.state.search || "";
    }
    const savedSearch = getAdvertStateFromStorage(id, 'advertSearch');
    return savedSearch || "";
  });
  const [advertSearch, setAdvertSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);
  const [releaseModal, setreleaseModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => {
    // Priority: location.state > check cleared flag > sessionStorage with expiration > default 1
    // Only use location.state.currentPage if flag is not set (to prevent override after global back)
    const wasCleared = sessionStorage.getItem(`advertPageCleared_${id}`);
    if (wasCleared !== 'true' && location.state?.currentPage !== undefined && location.state.currentPage > 0) {
      return location.state.currentPage;
    }
    // Check if pagination was cleared by global back
    if (wasCleared === 'true') {
      // Pagination was cleared - start at page 1 (don't remove flag yet, let useEffect handle it)
      return 1;
    }
    // Try to restore from sessionStorage (with expiration check)
    const savedPage = getAdvertStateFromStorage(id, 'advertPage');
    if (savedPage) {
      const pageNum = parseInt(savedPage);
      if (!isNaN(pageNum) && pageNum > 0) {
        return pageNum;
      }
    }
    return 1;
  });
  const [deleteLoading, setDeleteLoading] = useState(false);
  const subscription = JSON.parse(localStorage.getItem("subscription"));
  const [campaignID, setCampaignID] = useState("");
  const [transferData, setTransferData] = useState([]);
  const [oldAdvertId, setOldAdvertId] = useState("");
  const [profileId, setProfileId] = useState("");
  const [candidateName, setCandidateName] = useState("");
  const [reportLoading, setReportLoading] = useState(false);
  const [ehHrLoading, setEhHrLoading] = useState(false);
  const [reloadState, setReloadState] = useState(false);
  const [deleteKeys, setDeleteKeys] = useState();
  const [acceptRejectLoading, setAcceptRejectLoading] = useState(false);
  const [proofUploadModal, setProofUploadModal] = useState(false);
  const [proofFile, setProofFile] = useState(null);
  const [uploadingProof, setUploadingProof] = useState(false);
  const [pendingAcceptData, setPendingAcceptData] = useState(null);
  const prevIdRef = React.useRef(id);
  const pageBeforeSearchRef = React.useRef(null);
  const isInitialMountRef = React.useRef(true);
  const isNavigatingAwayRef = React.useRef(false);

   const [modalVisible, setModalVisible] = useState(false);
  const [incomingWorkforceVisible, setIncomingWorkforceVisible] = useState(false);
  const [tableHeight, setTableHeight] = useState(400);
  const [openProfileDrawer, setOpenProfileDrawer] = useState(false);
  const [profileDrawerData, setProfileDrawerData] = useState(null);
  const [favoritesList, setFavoritesList] = useState([]);
  const [favoriteLoading, setFavoriteLoading] = useState({});

  const handleReleaseClick = () => {
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };

  const selectedTableCandidates = () =>
    (candidateDetails?.result || []).filter((item) =>
      selectedRowKeys.includes(item?._id)
    );

  const hasHardReview = (candidate) => {
    const progress = candidate?.progress;
    const lastState =
      Array.isArray(progress) && progress.length
        ? progress[progress.length - 1]?.state
        : null;
    return lastState !== null && lastState !== undefined && Number(lastState) >= 3;
  };

  const allSelectedHaveHardReview = () =>
    selectedTableCandidates().length > 0 &&
    selectedTableCandidates().every(hasHardReview);

  const handleIncomingWorkforceOpen = () => {
    if (!selectedRowKeys.length) return;
    if (!allSelectedHaveHardReview()) {
      message.warning(
        "Select a candidate who has reached Hard Review."
      );
      return;
    }
    setIncomingWorkforceVisible(true);
  };

  const handleNextStep = (selectedClientId) => {
    console.log('Selected External Client ID:', selectedClientId);
    // Perform next step (e.g., API to assign candidate)
  };

  // Function to get responsive table height based on screen size
  const getTableHeight = () => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    
    // For very large screens (2500px+ width or height)
    if (screenWidth >= 2500 || screenHeight >= 2500) {
      return 800;
    }
    // For large screens in range 2100-2499px (width or height)
    else if ((screenWidth >= 2100 && screenWidth < 2500) || (screenHeight >= 2100 && screenHeight < 2500)) {
      return 800;
    }
    // For screens 2000px+ (to show 10 rows without scroll)
    // Height calculation: ~60px header + (10 rows × ~55px per row) = ~610px
    else if (screenWidth >= 1441 || screenHeight >= 1441) {
      return 600;
    }
    // For large screens (1440px+ width or height)
    else if (screenWidth >= 1440 || screenHeight >= 1440) {
      return 600;
    }
    // For medium screens (1200px+ width or height)
    else if (screenWidth >= 1200 || screenHeight >= 1200) {
      return 500;
    }
    // Default height for smaller screens
    else {
      return 400;
    }
  };

  // Update table height on window resize
  useEffect(() => {
    const updateTableHeight = () => {
      setTableHeight(getTableHeight());
    };

    // Set initial height
    updateTableHeight();

    // Add event listener for window resize
    window.addEventListener('resize', updateTableHeight);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateTableHeight);
    };
  }, []);


  const [selectedRowData, setSelectedRowData] = useState([]);

  const { state } = useLocation();
  console.log(state, "STTT");
  // const { state } = props;
  // console.log(state, "STTT");

  const handleAcceptReject = async (actionType, rawData) => {
    if (acceptRejectLoading) return;

    const currentUserId = localStorage.getItem("userID");
    const candidateUserId = rawData?.profileId?.userId?._id || rawData?.profileId?.userId?.id;
    const isCurrentUser = currentUserId && candidateUserId && currentUserId === candidateUserId;

    let isApproved;
    if (actionType === "accept") {
      isApproved = rawData?.isApproved === "accepted" ? "unaccept" : "accepted";
      
      // If accepting (not unaccepting)
      if (isApproved === "accepted") {
        // If user is Associate OR candidate is current user: proceed without upload
        if (userType === "Associate" || isCurrentUser) {
          await proceedWithAcceptReject(isApproved, rawData);
          return;
        }
        // If user is NOT Associate AND candidate is NOT current user: open proof upload modal
        else {
          setPendingAcceptData({ actionType, rawData, isApproved });
          setProofUploadModal(true);
          return;
        }
      }
      // If unaccepting, send empty string for attachment
      else if (isApproved === "unaccept") {
        await proceedWithAcceptReject(isApproved, rawData, "");
        return;
      }
    } else if (actionType === "reject") {
      isApproved = rawData?.isApproved === "rejected" ? "unreject" : "rejected";
      
      // If rejecting (not unrejecting)
      if (isApproved === "rejected") {
        // If user is Associate OR candidate is current user: proceed without upload
        if (userType === "Associate" || isCurrentUser) {
          await proceedWithAcceptReject(isApproved, rawData);
          return;
        }
        // If user is NOT Associate AND candidate is NOT current user: open proof upload modal
        else {
          setPendingAcceptData({ actionType, rawData, isApproved });
          setProofUploadModal(true);
          return;
        }
      }
      // If unrejecting, proceed directly without attachment
      else if (isApproved === "unreject") {
        await proceedWithAcceptReject(isApproved, rawData);
        return;
      }
    }

    // Fallback: proceed directly without proof
    await proceedWithAcceptReject(isApproved, rawData);
  };

  const proceedWithAcceptReject = async (isApproved, rawData, attachmentUrl = null) => {
    if (acceptRejectLoading) return;

    setAcceptRejectLoading(true);

    try {
      const payload = { isApproved };
      // Include attachment field if provided (including empty string for unaccept)
      if (attachmentUrl !== null && attachmentUrl !== undefined) {
        payload.attachment = attachmentUrl;
      }

      await API_MANAGER.acceptRejectCandidate(
        payload,
        candidateSelectedData?._id
      );

      message.success(
        `Candidate ${
          isApproved === "accepted"
            ? "accepted"
            : isApproved === "rejected"
            ? "rejected"
            : isApproved === "unaccept"
            ? "unaccepted"
            : isApproved === "unreject"
            ? "unrejected"
            : "marked as Pending"
        } successfully.`
      );

      // Refresh the candidate details to get updated data
      await getCandidateDetails();
      
      // Close modal and reset state
      setProofUploadModal(false);
      setProofFile(null);
      setPendingAcceptData(null);
    } catch (error) {
      message.error(
        error?.response?.data?.message?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setAcceptRejectLoading(false);
      setUploadingProof(false);
    }
  };

  const handleProofUpload = async () => {
    if (!proofFile) {
      message.warning("Please upload a proof document.");
      return;
    }

    setUploadingProof(true);

    try {
      // Step 1: Get file extension and type
      const fileExtension = proofFile.type?.split("/")[1] || "pdf";
      const contentType = proofFile.type || "application/pdf";

      // Step 2: Call file upload API to get upload URL
      const uploadData = {
        extension: fileExtension,
        type: "DOCUMENT",
        contentType: contentType,
      };

      const uploadResponse = await API_MANAGER.fileUpload(uploadData);
      const uploadUrl = uploadResponse?.data?.data?.url;
      const fileKey = uploadResponse?.data?.data?.key;

      if (!uploadUrl || !fileKey) {
        throw new Error("Failed to get upload URL");
      }

      // Step 3: Upload file to the URL
      await axios.put(uploadUrl, proofFile, {
        headers: {
          "Content-Type": contentType,
        },
      });

      // Step 4: Proceed with accept action using the file key/URL as string
      // Send fileKey (or the full URL) as attachment string in the payload
      await proceedWithAcceptReject(
        pendingAcceptData?.isApproved,
        pendingAcceptData?.rawData,
        fileKey
      );
    } catch (error) {
      setUploadingProof(false);
      message.error(
        error?.response?.data?.message ||
          "Failed to upload proof. Please try again."
      );
    }
  };

  const handleProofFileChange = (info) => {
    if (info.fileList.length > 0) {
      const file = info.fileList[info.fileList.length - 1];
      if (file.originFileObj) {
        setProofFile(file.originFileObj);
      } else if (file.status === 'removed') {
        setProofFile(null);
      }
    } else {
      setProofFile(null);
    }
  };

  const deleteAdvert = async () => {
    let campaignId = advertDetail?.campaignId?.id;
    setDeleteLoading(true);
    try {
      await API_MANAGER.deleteAdvert(id);
      message.success("Advert successfully deleted.");
      setDeleteLoading(false);
      setActiveDeleteModal(false);
      navigate(`/campaign-detail/${campaignId}`);
    } catch (error) {
      setDeleteLoading(false);
      message.error("Something went wrong. Please try again.");
    }
  };

  const handleCloneAdvert = async () => {
    try {
      const campaignId =
        advertDetail?.campaignId?.id ||
        advertDetail?.campaignId?._id ||
        campaignID;
      if (!campaignId) {
        message.error("Something went wrong. Please try again.");
        return;
      }
      const response = await API_MANAGER.getCampaignDetail(campaignId);
      const campaign = response?.data?.data;
      const advertId = advertDetail?.id || advertDetail?._id || id;
      navigate(`/create-advert?cloneId=${advertId}`, {
        state: {
          isClone: true,
          cloneAdvertId: advertId,
          advertDetail: campaign,
        },
      });
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  const getData = async () => {
    try {
      const response = await API_MANAGER.getAdvertDetail(id);
      setAdvertDetail(response?.data?.data);
      setCampaignID(response?.data?.data?.campaignId?.id);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  const checkFavoriteStatus = async () => {
    try {
      const response = await API_MANAGER.getAllFavourites();
      const favorites = response?.data?.data || [];
      setFavoritesList(favorites);
    } catch (error) {
      console.error("Error checking favorite status:", error);
    }
  };

  const isFavorite = (candidateId) => {
    if (!candidateId) return false;
    const candidateIdStr = String(candidateId);
    return favoritesList.some(fav => {
      if (!fav || !fav.candidateId) return false;
      const favCandidateId = fav.candidateId._id || fav.candidateId.id || (typeof fav.candidateId === 'string' ? fav.candidateId : null);
      if (!favCandidateId) return false;
      return String(favCandidateId) === candidateIdStr;
    });
  };

  const toggleFavorite = async (candidateId, e) => {
    if (e) {
      e.stopPropagation();
    }
    
    if (!candidateId) {
      return;
    }
    
    const candidateIdStr = String(candidateId);
    
    if (favoriteLoading[candidateIdStr]) {
      return;
    }
    
    setFavoriteLoading(prev => ({ ...prev, [candidateIdStr]: true }));
    
    const currentlyFavorite = isFavorite(candidateId);
    
    try {
      if (currentlyFavorite) {
        const favoriteEntry = favoritesList.find(fav => {
          if (!fav || !fav.candidateId) return false;
          const favCandidateId = fav.candidateId._id || fav.candidateId.id || (typeof fav.candidateId === 'string' ? fav.candidateId : null);
          if (!favCandidateId) return false;
          return String(favCandidateId) === candidateIdStr;
        });
        
        if (favoriteEntry?._id) {
          await API_MANAGER.removeFavourite(favoriteEntry?.candidateId?._id);
        } else {
          message.error("Could not find favorite entry ID. Please try again.");
          setFavoriteLoading(prev => ({ ...prev, [candidateIdStr]: false }));
          return;
        }
      } else {
        await API_MANAGER.addFavourite({ candidateId: candidateId });
      }
      
      await checkFavoriteStatus();
    } catch (error) {
      console.error("Error toggling favorite:", error);
      const errMsg = error?.response?.data?.message;
      message.error(typeof errMsg === 'string' ? errMsg : (errMsg?.message || "Failed to update favorite status."));
      await checkFavoriteStatus();
    } finally {
      setFavoriteLoading(prev => {
        const updated = { ...prev };
        delete updated[candidateIdStr];
        return updated;
      });
    }
  };

  const getCandidateDetails = async () => {
    setLoading(true);
    const param = {
      page: currentPage,
      limit: 10,
      sort: sortType,
      ...(search && { search: search }),
    };
    try {
      const response = await API_MANAGER.getAdvertCandidatesDetail(id, param);
      console.log(response, "TEST RESPONSE");
      setReloadState(false);
      setCandidatesDetails(response?.data?.data);
      setOldAdvertId(response?.data?.data?.result[0]?.advertId?._id);
      setProfileId(response?.data?.data?.result[0]?.profileId?._id);
      setCandidateName(response?.data?.data?.result[0]?.candidateName);
      await checkFavoriteStatus();
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  const bulkassign = async (value, id) => {
    setLoading(true);
    const data = {
      value: value,
      applicationIds: id ? [id] : selectedRowKeys,
    };
    try {
      const response = await API_MANAGER.bulkRelease(data);
      if (value) {
        message.success("Application successfully released.");
      } else {
        message.success("Application successfully unreleased.");
      }

      // setReloadState(false);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
    setReloadState(!reloadState);
    setreleaseModal(false);
    setLoading(false);
  };

  const handelAssign = () => {
    setreleaseModal(true);
  };

  // useEffect(() => {
  //   console.log(state,"DTAASTETE")
  //   setSearch(state);
  // }, [state]);

  const getAdvertData = async (id) => {
    setLoading(true);
    // let params = {
    //   page: 1,
    //   limit: 100,
    //   sort: "-createdAt",
    // };
    let params = {
      profileId: candidateSelectedData?.profileId?._id,
      sort: "-createdAt",
      limit: 20000,
      page: 1,
    };
    if (advertSearch) {
      params = { ...params, ["search"]: advertSearch };
    }
    if (userType !== "Associate") {
      try {
        const response = await API_MANAGER.getSingleUserCampaignDetails(params);
        setTransferData(response?.data?.data);
      } catch (error) {
        message.error("Something went wrong. Please try again.");
      }
    }
    setLoading(false);
  };
  const userType = localStorage.getItem("user");
  useEffect(() => {
    getData();
  }, [id]);
  useEffect(() => {
    getCandidateDetails();
  }, [search, sortType, currentPage, id, reloadState == true]);

  useEffect(() => {
    checkFavoriteStatus();
  }, []);
  useEffect(() => {
    getAdvertData();
  }, [advertSearch]);
  useEffect(() => {
    const refreshCampaignData = () => {
      getData();
      getAdvertData();
      getCandidateDetails();
    };
    window.addEventListener("refreshCampaignData", refreshCampaignData);
    return () =>
      window.removeEventListener("refreshCampaignData", refreshCampaignData);
  }, [id, search, sortType, currentPage, advertSearch]);
  const items = [
    {
      key: "1",
      label: (
        <Radio.Group
          className="dropDown_radio_group"
          onChange={(e) => setSortType(e?.target?.value)}
        >
          <Row className="filter_item_row">
            <Col span={24} className="">
              <Radio value={"-createdAt"}>Latest First</Radio>
            </Col>
          </Row>
          <Row className="filter_item_row">
            <Col span={24} className="">
              <Radio value={"createdAt"}>Oldest First</Radio>
            </Col>
          </Row>
          <Row className="filter_item_row">
            <Col span={24} className="">
              <Radio value={"candidateName"}>Sort by A-Z</Radio>
            </Col>
          </Row>
          <Row className="filter_item_row">
            <Col span={24} className="">
              <Radio value={"-candidateName"}>Sort by Z-A</Radio>
            </Col>
          </Row>
        </Radio.Group>
      ),
    },
  ];

  const columns = [
    {
      title: (
        <div>
          <span style={{ marginRight: "10px" }}>Name</span>
          <Dropdown
            menu={{ items }}
            overlayClassName="notificationFilterDropdown "
          >
            <img src={FilterIcon} className="cursor_pointer" alt="filter" />
          </Dropdown>
        </div>
      ),
      dataIndex: "name",
      fixed: "left",
      // render: (item, record) => (

      // ),
     render: (item, row) => {
   
  const candidateId = row?.profileId?._id || row?.profileId?.id;
  const isCandidateFavorite = isFavorite(candidateId);
  const isLoadingFavorite = favoriteLoading[String(candidateId)];

  const tooltipContent = (
    <div>
      <span>Contact Details</span>
      {row?.profileId?.phoneNumber && (
        <Row gutter={8} align="middle">
          <Col>
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
              <circle cx="4" cy="4" r="4" fill="#31B948" />
            </svg>
          </Col>
          <Col>{"0" + row?.profileId?.phoneNumber}</Col>
        </Row>
      )}

      {row?.profileId?.userId?.email && (
        <Row gutter={8} align="middle">
          <Col>
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
              <circle cx="4" cy="4" r="4" fill="#31B948" />
            </svg>
          </Col>
          <Col>{row?.profileId?.userId?.email}</Col>
        </Row>
      )}
    </div>
  );

  const rocketIconElement = row?.isReleased ? (
    <Tooltip 
      title="Released to client" 
      placement="bottom"
      destroyTooltipOnHide={true}
      mouseEnterDelay={0.1}
    >
      <img
        src={rocketIcon}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onMouseEnter={(e) => {
          e.stopPropagation();
        }}
        onMouseLeave={(e) => {
          e.stopPropagation();
        }}
        style={{
          height: "22px",
          padding: "3px",
          borderRadius: "8px",
          background: "#EBEEF7",
          flexShrink: 0,
        }}
      />
    </Tooltip>
  ) : null;

  const nameSpan = (
    <span
      onClick={() => {
        setProfileDrawerData(row);
        setOpenProfileDrawer(true);
      }}
      className={
        row?.isRejected
          ? "rejected_candidate cursor-pointer"
          : row?.final_select
          ? "selected_candidate_div cursor-pointer table-font-14"
          : "cursor-pointer table-font-14"
      }
      style={{ minWidth: 0 }}
    >
      {row?.isApproved === "accepted" ? (
        <span className="approvedStyle">
          <span>{row?.profileId?.name}</span>
        </span>
      ) : row?.isApproved === "rejected" ? (
        <span>
          <strike className="rejectStyleClass">
            {row?.profileId?.name}
          </strike>
        </span>
      ) : (
        <span>
          {row?.profileId?.name}
        </span>
      )}
    </span>
  );

  const nameContent = (
    <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
      {userType !== "Associate" && (
      <Tooltip 
        title={isCandidateFavorite ? "Remove from favourite" : "Click to mark as favourite"} 
        placement="bottom"
        destroyTooltipOnHide={true}
        mouseEnterDelay={0.1}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            toggleFavorite(candidateId, e);
          }}
          onMouseEnter={(e) => {
            e.stopPropagation();
          }}
          onMouseLeave={(e) => {
            e.stopPropagation();
          }}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "20px",
            height: "20px",
            flexShrink: 0,
            opacity: isLoadingFavorite ? 0.6 : 1,
            pointerEvents: isLoadingFavorite ? "none" : "auto",
          }}
        >
          {isCandidateFavorite ? (
            <div
              style={{
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                backgroundColor: "#facc15",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                  fill="white"
                />
              </svg>
            </div>
          ) : (
            <div
              style={{
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                border: "1.5px solid #666",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                  stroke="#666"
                  strokeWidth="1.5"
                  fill="none"
                />
              </svg>
            </div>
          )}
        </div>
      </Tooltip>
      )}
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          flex: userType === "Associate" ? "none" : 1,
          minWidth: 0,
        }}
      >
        {row?.hardReview || row?.progress?.length > 0 ? (
          <Tooltip
            title={tooltipContent}
            placement="top"
            destroyTooltipOnHide={true}
            mouseEnterDelay={0.1}
          >
            {nameSpan}
          </Tooltip>
        ) : (
          nameSpan
        )}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: userType === "Associate" ? 0 : "auto", flexShrink: 0 }}>
        {userType !== "Associate" && (
          <CandidateTransferBadges row={row} advertId={id} />
        )}
        {rocketIconElement}
        {row?.attachment && (
          <Tooltip 
            title="Proof of approval"
            placement="top"
            destroyTooltipOnHide={true}
            mouseEnterDelay={0.1}
          >
            <Button
              type="default"
              shape="square"
              size="small"
              onClick={async (e) => {
                e.stopPropagation();
                try {
                  if (row.attachment.startsWith('http')) {
                    window.open(row.attachment, '_blank');
                    return;
                  }
                  
                  const fileKey = row.attachment;
                  let cleanKey = fileKey;
                  if (fileKey.startsWith('DOCUMENT/')) {
                    cleanKey = fileKey.replace('DOCUMENT/', '');
                  }
                  
                  const attachmentUrl = `https://dev-documents-cinchy.s3.ap-southeast-2.amazonaws.com/DOCUMENT/${cleanKey}`;
                  window.open(attachmentUrl, '_blank');
                } catch (error) {
                  message.error("Failed to open document. Please try again.");
                }
              }}
              onMouseEnter={(e) => {
                e.stopPropagation();
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
              }}
              style={{
                width: "24px",
                height: "24px",
                padding: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="2"
                  y="2"
                  width="12"
                  height="12"
                  rx="1"
                  stroke="#1638B1"
                  strokeWidth="1.5"
                  fill="none"
                />
                <path
                  d="M6 10L10 6M10 6H7.33333M10 6V8.66667"
                  stroke="#1638B1"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Button>
          </Tooltip>
        )}
      </div>
    </div>
  );

  return nameContent;
}

    },

    {
      title: "Invited",
      align: "center",

      dataIndex: "invited",
      render: (item, record) => (
        <>
          {record?.isInvited ? (
            <img src={checkFilled_image} />
          ) : (
            <img src={unCheckFilled_image} />
          )}
        </>
      ),
    },
    {
      title: "Applied",
      dataIndex: "applied",
      align: "center",

      render: (item, record) =>
        record?.progress?.length > 0 ? (
          <img src={checkFilled_image} />
        ) : (
          <img src={unCheckFilled_image} />
        ),
    },
    {
      title: (
        <div>
          Shortlists<br></br>Offered
        </div>
      ),
      dataIndex: "shortlists_offered",
      align: "center",

      render: (item, record) =>
        record?.progress &&
        record?.progress?.[record?.progress?.length - 1]?.state >= 2 ? (
          <img src={checkFilled_image} />
        ) : (
          <img src={unCheckFilled_image} />
        ),
    },
    {
      title: (
        <div>
          Hard<br></br>Review
        </div>
      ),
      dataIndex: "hard_review",
      align: "center",
      render: (item, record) =>
        record?.progress &&
        record?.progress[record?.progress?.length - 1]?.state >= 3 ? (
          <img src={checkFilled_image} />
        ) : (
          <img src={unCheckFilled_image} />
        ),
    },
    {
      title: (
        <div>
          Role<br></br>Offered
        </div>
      ),
      dataIndex: "role_offered",
      align: "center",

      render: (item, record) =>
        record?.progress &&
        record?.progress[record?.progress?.length - 1]?.state >= 4 ? (
          <img src={checkFilled_image} />
        ) : (
          <img src={unCheckFilled_image} />
        ),
    },
    {
      title: (
        <div>
          Role<br></br>Accepted
        </div>
      ),
      dataIndex: "roleAccepted",
      align: "center",

      render: (item) =>
        item ? (
          <img src={checkFilled_image} />
        ) : (
          <img src={unCheckFilled_image} />
        ),
    },
    {
      title: "",
      dataIndex: "action",
      align: "center",

      render: (item, rawData) => (
        <Row align={"middle"}>
          <Dropdown
            placement="left"
            overlayClassName="action-dropdown"
            menu={{
              items: actionItems(rawData),
            }}
            trigger={"click"}
          >
            <img
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setCandidateSelectedData(rawData);
              }}
              className="cursor_pointer"
              src={infoIcon}
              alt="edit"
            />
          </Dropdown>
        </Row>
      ),
    },
  ];

  const updateCandidateJobStatus = async () => {
    try {
      const currentState = candidateSelectedData?.progress?.[
        candidateSelectedData?.progress?.length - 1
      ]?.state;
      
      // Recruiter actions: Can offer Shortlist from state 0, and offer Role from state 3
      if (
        currentState === 0 || currentState === "0" || Number(currentState) === 0
      ) {
        // Recruiter can offer Shortlist from Applied state
        await API_MANAGER.updateCandidateJobStatus(candidateSelectedData?._id, {
          status: "SHORTLIST_OFFERED",
        });
      } else if (
        candidateSelectedData?.progress?.[
          candidateSelectedData?.progress?.length - 1
        ]?.state === 2
      ) {
        // Candidate action: Accept Shortlist Offer (state 2 → 3)
        // This should be done by candidate, but recruiter can trigger it
        await API_MANAGER.acceptShortlistOffer({
          applicationId: candidateSelectedData?._id,
          acceptance: true,
        });
      } else if (
        candidateSelectedData?.progress?.[
          candidateSelectedData?.progress?.length - 1
        ]?.state === 3
      ) {
        // Recruiter action: Offer Role from Hard Review state
        await API_MANAGER.updateCandidateJobStatus(candidateSelectedData?._id, {
          status: "ROLE_OFFERED",
        });
      } else {
        // Invalid state transition
        setUpdatePopup(false);
        return;
      }

      message.success("Status successfully updated.");
      setUpdatePopup(false);
      getCandidateDetails();
      getData();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "A Candidate must accept your previous request, before you can push them to the next stage of the recruitment process."
      );
      setUpdatePopup(false);
    }
  };
  const updateBulkCandidateJobStatus = async () => {
    try {
      if (
        selectedRowData[0]?.progress[selectedRowData[0]?.progress?.length - 1]
          ?.state === 0
      ) {
        const param = {
          applicationIds: [...selectedRowKeys],
          status: "SHORTLIST_OFFERED",
        };
        await API_MANAGER.updateBulkCandidateJobStatus(param);
        message.success("Status successfully updated.");
        getCandidateDetails();
      } else if (
        selectedRowData[0]?.progress[selectedRowData[0]?.progress?.length - 1]
          ?.state === 3
      ) {
        const param = {
          applicationIds: [...selectedRowKeys],
          status: "ROLE_OFFERED",
        };
        await API_MANAGER.updateBulkCandidateJobStatus(param);

        message.success("Status successfully updated.");
        getCandidateDetails();
      } else {
        setStatusModal(false);
        message.error(
          "A Candidate must accept your previous request, before you can push them to the next stage of the recruitment process."
        );
        return;
      }
      setStatusModal(false);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
      // setUpdateAlert(true);
    }
  };
  const onSelectChange = (newSelectedRowKeys) => {
    let updatedSelectedCandidates = [];
    // newSelectedRowKeys.filter((e)=> )
    const temp = candidateDetails?.result?.filter((e) => {
      if (newSelectedRowKeys.includes(e?._id)) {
        return e;
      } else {
        return null;
      }
    });
    setSelectedRowData(temp);
    newSelectedRowKeys.map((e, item_index) => {
      updatedSelectedCandidates.push(candidateDetails?.result[item_index - 1]);
    });

    setSelectedCandidates(updatedSelectedCandidates);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const handleStatusButton = () => {
    let tempBool = false;
    if (selectedRowData?.length <= 1) {
      setStatusModal(true);
    } else if (selectedRowData?.length > 1) {
      if (selectedRowData[0]?.progress) {
        const tempState =
          selectedRowData[0]?.progress[selectedRowData[0]?.progress?.length - 1]
            ?.state;
        selectedRowData?.map((e) => {
          if (e?.progress) {
            if (e?.progress[e?.progress?.length - 1]?.state !== tempState) {
              setErrorNotification(true);
              tempBool = true;
              setTimeout(() => {
                setErrorNotification(false);
              }, 3000);
            }
          } else {
            const tempState1 = selectedRowData[0]?.isInvited;
            if (e?.isInvited !== tempState1) {
              setErrorNotification(true);
              tempBool = true;
              setTimeout(() => {
                setErrorNotification(false);
              }, 3000);
            }
          }
        });
      } else {
        const tempState = selectedRowData[0]?.isInvited;
        selectedRowData.map((e) => {
          if (e?.isInvited !== tempState) {
            setErrorNotification(true);
            tempBool = true;
            setTimeout(() => {
              setErrorNotification(false);
            }, 3000);
            return;
          }
        });
      }
      if (!tempBool) {
        setStatusModal(true);
      }
    } else {
      setErrorNotification(true);
      setTimeout(() => {
        setErrorNotification(false);
      }, 3000);
    }
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;
  const handleUpdagradeMembership = () => {
    if (localStorage.getItem("isPlusSubscription")) console.log("downloaddd");
    else setUpgradeMembership(true);
  };
  const handleTrackerClick = () => {
    if (JSON.parse(localStorage.getItem("isPlusSubscription"))) {
      // Get the current tab type from sessionStorage or use default
      const currentTabType = sessionStorage.getItem(`trackerTabType_${advertDetail?.id}`) || location.state?.tabType || "HARD_REQUIREMENTS";
      navigate(`/advert-tracker/${advertDetail?.id}`, {
        state: {
          search: search,
          currentPage: currentPage,
          fromAdvertDetail: true,
          tabType: currentTabType,
          campaignId: location.state?.campaignId || campaignID,
          fromCampaignDetail: location.state?.fromCampaignDetail || false,
          originalSource: location.state?.originalSource || (location.state?.fromCampaignDetail ? 'campaign-detail' : 'campaign-management'),
          fromJobAdvert: location.state?.fromJobAdvert || false,
        }
      });
    } else setUpgradeMembership(true);
  };
  const candidateReport = async () => {
    setReportLoading(true);
    try {
      const response = await API_MANAGER.getCandidateReport(id);
      downloadPDF(response?.data?.data, "Candidate Report");
      setReportLoading(false);
    } catch (error) {
      setReportLoading(false);
      message.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    }
  };
  const ehHrReport = async () => {
    setEhHrLoading(true);
    try {
      const response = await API_MANAGER.ehHrReport({ advertId: id });
      const campaignName =
        advertDetail?.campaignId?.name ||
        advertDetail?.campaignId?.campaignName ||
        advertDetail?.campaignId?.id ||
        "Campaign";
      const advertName = advertDetail?.jobTitle?.name || id;
      const fileBaseName = `CSV - ${campaignName} - ${advertName}`;
      downloadCsv(response?.data, fileBaseName);
      setEhHrLoading(false);
    } catch (error) {
      setEhHrLoading(false);
      message.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    }
  };

  const handelisRemoved = async (id) => {
    const param = {
      applicationIds: [id],
      value: false,
    };
    try {
      const response = await API_MANAGER.bulkMobilizationDelete(param);

      message.success("Profile added to Mobilisation Management.");
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  // const handleAcceptReject = async (value) => {
  //   setLoading(true);
  //   try {
  //     await API_MANAGER.acceptRejectCandidate(
  //       { isApproved: value },
  //       candidateSelectedData?._id
  //     );
  //     message.success("Successfully updated candidate.");
  //     getCandidateDetails();
  //   } catch (error) {
  //     message.error(
  //       error.response.data.message.message ||
  //         "Something went wrong. Please try again."
  //     );
  //   }
  //   setLoading(false);
  // };
  const handleDelete = async () => {
    const params = {
      applicationIds: [...selectedRowKeys],
    };
    setDeleteKeys(params);
    setBulkDeleteModal(true);
  };
  const handleDeleteSubmit = async () => {
    try {
      const response = await API_MANAGER.bulkApplicationDelete(deleteKeys);
      message.success("Application(s) successfully deleted.");
      setDeleteKeys(null);
      setBulkDeleteModal(false);
      getCandidateDetails();
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };
  const actionItems = (rawData) => [
    {
      key: "1",
      label: (
        <div className="action-dropdown">
          {userType !== "Associate" ? (
            <>
              <Row>
                <Col
                  onClick={() => setUpdatePopup(true)}
                  className="item"
                  span={24}
                >
                  <img src={status_image} />
                  <span>Status</span>
                </Col>
              </Row>
              <Row>
                <Col
                  onClick={() => {
                    const params = {
                      applicationIds: [candidateSelectedData?._id],
                    };
                    setDeleteKeys(params);
                    setBulkDeleteModal(true);
                  }}
                  className="item"
                  span={24}
                >
                  <img src={action_delete} />
                  <span>Remove</span>
                </Col>
              </Row>
              <Row>
                <Col
                  onClick={() => {
                    getAdvertData();
                    setTransferModal({ transfer: true });
                  }}
                  className="item"
                  span={24}
                >
                  <img src={transeferImage} />
                  <span>Transfer</span>
                </Col>
              </Row>
              <Row>
                <Col
                  onClick={() => {
                    setTransferUserModal(true);
                  }}
                  className="item"
                  span={24}
                >
                  <img src={shareIcon} />
                  <span>Forward candidate</span>
                </Col>
              </Row>
              {rawData?.isRemovedMobi && (
                <Row>
                  <Col
                    onClick={() => handelisRemoved(rawData?._id)}
                    className="item"
                    span={24}
                  >
                    <img src={rocketIcon} height={15} width={15} />
                    <span>Re-add to mobilisation</span>
                  </Col>
                </Row>
              )}

              {rawData?.isReleased ? (
                <Row>
                  <Col
                    onClick={() => bulkassign(false, rawData?._id)}
                    className="item"
                    span={24}
                  >
                    <img
                      src={rocketIcon}
                      height={15}
                      width={15}
                      style={{ rotate: "180deg" }}
                    />
                    <span>Unrelease</span>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col
                    onClick={() => bulkassign(true, rawData?._id)}
                    className="item"
                    span={24}
                  >
                    <img src={rocketIcon} height={15} width={15} />
                    <span>Release</span>
                  </Col>
                </Row>
              )}

              <Row>
                <Col
                  onClick={() => setReportModal(true)}
                  className="item"
                  span={24}
                >
                  <img src={alert_triangle} />
                  <span>{reportLoading ? "Downloading..." : "Report"}</span>
                </Col>
              </Row>
               <>
              {/* Accept/Unaccept Button */}
              <Row>
                <Col
                  onClick={() => handleAcceptReject("accept", rawData)}
                  className={`item ${acceptRejectLoading ? "disabled" : ""}`}
                  span={24}
                  style={{ cursor: acceptRejectLoading ? "not-allowed" : "pointer" }}
                >
                  <img src="/unaccept.svg" alt="Accept/Unaccept" />
                  <span>
                    {acceptRejectLoading ? "Processing..." : (rawData?.isApproved == "accepted" ? "Unaccept" : "Accept")}
                  </span>
                </Col>
              </Row>

              {/* Reject/Unreject Button */}
              {/* <Row>
                <Col
                  onClick={() => handleAcceptReject("reject", rawData)}
                  className={`item ${acceptRejectLoading ? "disabled" : ""}`}
                  span={24}
                  style={{ cursor: acceptRejectLoading ? "not-allowed" : "pointer" }}
                >
                  <img src={action_delete} alt="Action" />
                  <span>
                    {acceptRejectLoading ? "Processing..." : (rawData?.isApproved == "rejected" ? "Unreject" : "Reject")}
                  </span>
                </Col>
              </Row> */}
            </>
            </>
          ) : (
            <>
              {/* Accept/Unaccept Button */}
              <Row>
                <Col
                  onClick={() => handleAcceptReject("accept", rawData)}
                  className={`item ${acceptRejectLoading ? "disabled" : ""}`}
                  span={24}
                  style={{ cursor: acceptRejectLoading ? "not-allowed" : "pointer" }}
                >
                  <img src="/unaccept.svg" alt="Accept/Unaccept" />
                  <span>
                    {acceptRejectLoading ? "Processing..." : (rawData?.isApproved == "accepted" ? "Unaccept" : "Accept")}
                  </span>
                </Col>
              </Row>

              {/* Reject/Unreject Button */}
              <Row>
                <Col
                  onClick={() => handleAcceptReject("reject", rawData)}
                  className={`item ${acceptRejectLoading ? "disabled" : ""}`}
                  span={24}
                  style={{ cursor: acceptRejectLoading ? "not-allowed" : "pointer" }}
                >
                  <img src={action_delete} alt="Action" />
                  <span>
                    {acceptRejectLoading ? "Processing..." : (rawData?.isApproved == "rejected" ? "Unreject" : "Reject")}
                  </span>
                </Col>
              </Row>

              {/* Forward Profile Button */}
              <Row>
                <Col
                  onClick={() => {
                    setTransferUserModal(true);
                  }}
                  className="item"
                  span={24}
                >
                  <img src={shareIcon} />
                  <span>Forward candidate</span>
                </Col>
              </Row>
            </>
          )}
        </div>
      ),
    },
  ];
  const tableHeaderPop = [
    {
      key: "1",
      label: (
        <Row gutter={[0, 10]} className="dropDown_radio_group">
          <Col
            className="filter_item_row"
            span={24}
            style={{ display: "flex", alignItems: "center" }}
            onClick={selectedRowKeys?.length > 0 ? handleDelete : null}
          >
            {/* <Row  align={"middle"} justify={"center"}> */}
            {/* <Col> */}
            <CommonDeleteSvg
              color={selectedRowKeys?.length > 0 ? "#D03C28" : "#A7AEBB"}
            />
            {/* </Col> */}
            <span
              style={{
                color: selectedRowKeys?.length > 0 ? "#D03C28" : "#A7AEBB",
              }}
            >
              Delete
            </span>
            {/* </Row> */}
          </Col>
          <Col
            className="filter_item_row"
            span={24}
            onClick={selectedRowKeys?.length > 0 ? handleStatusButton : null}
            style={{ marginLeft: "2%" }}
          >
            <img src={status_image} /> <span>Status</span>
          </Col>
          <Col
            className="filter_item_row"
            span={24}
            onClick={() => candidateReport()}
          >
            <img src={downloadIcon} /> <span>Report</span>
          </Col>
          <Col className="filter_item_row" span={24} onClick={ehHrReport}>
            <img src={downloadIcon} />
            <span>{ehHrLoading ? "Downloading..." : "Export"}</span>
          </Col>
        </Row>
      ),
    },
  ];
  console.log(location,"LOCATION oF ADVERT")
    useEffect(() => {
    // Reset navigation flag when component mounts/updates (new navigation)
    isNavigatingAwayRef.current = false;
    
    // Check if pagination was cleared by global back FIRST (before any other checks)
    const wasCleared = sessionStorage.getItem(`advertPageCleared_${id}`);
    
    if (wasCleared === 'true') {
      // Pagination was cleared by global back - always start at page 1
      // Ensure the value is cleared from sessionStorage (in case it was restored)
      sessionStorage.removeItem(`advertPage_${id}`);
      sessionStorage.removeItem(`advertSearch_${id}`);
      setCurrentPage(1);
      sessionStorage.removeItem(`advertPageCleared_${id}`); // Remove the flag
      isInitialMountRef.current = false; // Allow storage after user changes page
      return; // Exit early, don't check location.state or sessionStorage
    }
    
    // Restore currentPage from location.state or sessionStorage (with expiration)
    if (location.state?.currentPage !== undefined && location.state.currentPage > 0) {
      setCurrentPage(location.state.currentPage);
      saveAdvertStateWithTimestamp(id, 'advertPage', location.state.currentPage.toString());
      isInitialMountRef.current = false; // Allow storage after explicit state
    } else {
      // Only restore from sessionStorage if it exists and not expired
      const savedPage = getAdvertStateFromStorage(id, 'advertPage');
      if (savedPage) {
        const pageNum = parseInt(savedPage);
        if (!isNaN(pageNum) && pageNum > 0) {
          setCurrentPage(pageNum);
          isInitialMountRef.current = false; // Allow storage after restore
        } else {
          setCurrentPage(1);
        }
      } else {
        // If no saved page or expired, ensure we're on page 1
        setCurrentPage(1);
      }
    }
    
    // Restore search from location.state or sessionStorage (with expiration)
    if (location.state?.search !== undefined) {
      const searchValue = location.state.search || "";
      setSearch(searchValue);
      if (searchValue) {
        saveAdvertStateWithTimestamp(id, 'advertSearch', searchValue);
      } else {
        sessionStorage.removeItem(`advertSearch_${id}`);
      }
    } else {
      // If location.state doesn't have search, restore from sessionStorage (with expiration)
      const savedSearch = getAdvertStateFromStorage(id, 'advertSearch');
      if (savedSearch) {
        setSearch(savedSearch);
      }
    }
  }, [location.pathname, location.key, id]);
  
  useEffect(() => {
    if (search) {
      saveAdvertStateWithTimestamp(id, 'advertSearch', search);
    } else {
      sessionStorage.removeItem(`advertSearch_${id}`);
    }
  }, [search, id]);
  
  useEffect(() => {
    // Don't store if we're navigating away (prevents storing when clicking back)
    if (isNavigatingAwayRef.current) {
      console.log('Storage prevented - navigating away');
      return;
    }
    
    // ALWAYS check flag first - don't store if pagination was cleared by global back
    const wasCleared = sessionStorage.getItem(`advertPageCleared_${id}`);
    if (wasCleared === 'true') {
      console.log('Storage prevented - flag exists');
      // Flag exists - don't store yet, wait for flag to be removed
      // Also ensure the value is cleared (in case it was set before flag check)
      sessionStorage.removeItem(`advertPage_${id}`);
      sessionStorage.removeItem(`advertSearch_${id}`);
      return; // Exit early - don't store anything
    }
    
    // Only store in sessionStorage if:
    // 1. We're not on initial mount (to avoid storing default value)
    // 2. OR we have location.state.currentPage (meaning we came with explicit state)
    // This prevents storing when returning after global back cleared sessionStorage
    if (!isInitialMountRef.current || location.state?.currentPage !== undefined) {
      saveAdvertStateWithTimestamp(id, 'advertPage', currentPage.toString());
    }
    // Mark that initial mount is complete
    if (isInitialMountRef.current) {
      isInitialMountRef.current = false;
    }
  }, [currentPage, id, location.state?.currentPage]);
  
  // Reset to page 1 when advert id changes (but preserve page if coming from navigation with state)
  useEffect(() => {
    // Only reset if id actually changed and we don't have a preserved page in location.state
    if (prevIdRef.current !== id && prevIdRef.current) {
      if (!location.state?.currentPage) {
        setCurrentPage(1);
        sessionStorage.removeItem(`advertPage_${prevIdRef.current}`);
      }
      // Reset search if id changed and we don't have a preserved search in location.state
      if (location.state?.search === undefined) {
        setSearch("");
        sessionStorage.removeItem(`advertSearch_${prevIdRef.current}`);
      }
      // Reset page before search ref when advert id changes
      pageBeforeSearchRef.current = null;
    }
    prevIdRef.current = id;
  }, [id, location.state]);
  
  // Custom back function to preserve mobilisation filters when navigating back
  const handleBackFromAdvert = () => {
    console.log('handleBackFromAdvert called', { id, locationState: location.state });
    
    // Mark that we're navigating away to prevent storage useEffect from running
    isNavigatingAwayRef.current = true;
    
    // ALWAYS clear pagination when back button is clicked (user wants to reset pagination)
    console.log('Clearing pagination for advertId:', id);
    // Set flag FIRST to prevent any storage operations from restoring the value
    sessionStorage.setItem(`advertPageCleared_${id}`, 'true');
    // Clear pagination and search from sessionStorage
    sessionStorage.removeItem(`advertPage_${id}`);
    sessionStorage.removeItem(`advertSearch_${id}`);
    // Force clear again immediately to ensure it's removed
    sessionStorage.removeItem(`advertPage_${id}`);
    sessionStorage.removeItem(`advertSearch_${id}`);
    console.log('After clearing, value:', sessionStorage.getItem(`advertPage_${id}`));
    
    // Determine if this is a "global back" (navigating to main routes, not internal navigation)
    const isGlobalBack = !location.state?.fromApplicantProfile && 
                         !location.state?.fromTracker && 
                         !location.state?.fromMobilisation &&
                         (!location.state?.fromCampaignDetail || !location.state?.campaignId);
    
    const userType = localStorage.getItem("user");

    if (location.state?.fromJobAdvert || userType === "Associate") {
      navigate(`/job-advert`);
      return;
    }

    if (location.state?.fromMobilisation && location.state?.mobilisationFilterState) {
      navigate(`/mobilisation-management`, {
        state: {
          currentPage: location.state.mobilisationFilterState.currentPage || location.state.currentPage,
          filterState: location.state.mobilisationFilterState,
        },
      });
    } else if (location.state?.fromApplicantProfile) {
      // If we came from Applicant Profile, navigate directly to the original source
      // This prevents the loop by skipping the intermediate Advert Detail entry
      const targetCampaignId = location.state?.campaignId || campaignID;
      
      if (location.state?.originalSource === 'campaign-detail' && targetCampaignId) {
        // Navigate directly to Campaign Detail with state indicating we came from Advert Detail
        navigate(`/campaign-detail/${targetCampaignId}`, { 
          state: { 
            fromAdvertDetail: true,
            advertSearch: search,
            advertCurrentPage: currentPage,
            advertId: id
          },
          replace: true 
        });
      } else if (location.state?.originalSource === 'campaign-management') {
        // Navigate directly to Campaign Management, replacing current entry
        navigate(`/campaign-management`, { replace: true });
      } else if (targetCampaignId) {
        // Fallback: navigate to campaign detail with state
        navigate(`/campaign-detail/${targetCampaignId}`, { 
          state: { 
            fromAdvertDetail: true,
            advertSearch: search,
            advertCurrentPage: currentPage,
            advertId: id
          },
          replace: true 
        });
      } else {
        // Last resort: go back 2 steps to skip both Advert Detail entries
        navigate(-2);
      }
    } else if (location.state?.fromTracker) {
      // If we came from Tracker, navigate back to the original source (Campaign Detail or Campaign Management)
      const targetCampaignId = location.state?.campaignId || campaignID;
      
      if (location.state?.fromCampaignDetail && targetCampaignId) {
        // Navigate back to Campaign Detail
        navigate(`/campaign-detail/${targetCampaignId}`, {
          state: { 
            fromAdvertDetail: true,
            advertSearch: search,
            advertCurrentPage: currentPage,
            advertId: id
          },
          replace: true
        });
      } else if (location.state?.originalSource === 'campaign-management') {
        // Navigate back to Campaign Management
        navigate(`/campaign-management`, { replace: true });
      } else if (targetCampaignId) {
        // Fallback: navigate to campaign detail
        navigate(`/campaign-detail/${targetCampaignId}`, {
          state: { 
            fromAdvertDetail: true,
            advertSearch: search,
            advertCurrentPage: currentPage,
            advertId: id
          },
          replace: true
        });
      } else {
        // Last resort: go back
        navigate(-1);
      }
    } else if (location.state?.fromCampaignDetail && location.state?.campaignId) {
      // If we came directly from Campaign Detail (without going through Applicant Profile), navigate back there
      navigate(`/campaign-detail/${location.state.campaignId}`, {
        state: { 
          fromAdvertDetail: true,
          advertSearch: search,
          advertCurrentPage: currentPage,
          advertId: id
        }
      });
    } else {
      // Global back - clear pagination sessionStorage
      // Set flag FIRST to prevent any storage operations from restoring the value
      sessionStorage.setItem(`advertPageCleared_${id}`, 'true');
      // Clear pagination and search from sessionStorage
      sessionStorage.removeItem(`advertPage_${id}`);
      sessionStorage.removeItem(`advertSearch_${id}`);
      // Force clear again immediately to ensure it's removed
      sessionStorage.removeItem(`advertPage_${id}`);
      sessionStorage.removeItem(`advertSearch_${id}`);
      
      // Determine the campaign ID to navigate back to
      const targetCampaignId = location.state?.campaignId || campaignID;
      
      if (targetCampaignId) {
        // Navigate to campaign detail without preserving pagination
        navigate(`/campaign-detail/${targetCampaignId}`);
      } else {
        // Navigate back without preserving pagination
        navigate(-1);
      }
    }
  };
  
  return (
    <SubLayout 
      currentPage={currentPage} 
      page={"Advert Details"} 
      showBack 
      showSearch
      backUrlFunction={handleBackFromAdvert}
      isBackFunc={location.state?.fromJobAdvert || location.state?.fromMobilisation || location.state?.fromApplicantProfile || location.state?.fromCampaignDetail || location.state?.fromTracker}
    >
      {errorNotification && <NotificationPopup />}
      <ProfileDrawer
        open={openProfileDrawer}
        setOpen={setOpenProfileDrawer}
        data={profileDrawerData}
        advertId={id}
        currentPage={currentPage}
        search={search}
        filterType={undefined}
        tabType={undefined}
        locationState={location.state}
      />
      <UpgradeMembershipModal
        setUpgradeMembership={setUpgradeMembership}
        upgradeMembership={upgradeMembership}
      />
      <Modal
        className="candidateDeleteModal"
        centered
        getContainer={document.body}
        title={pendingAcceptData?.isApproved === "rejected" ? "Upload Proof Document for Rejection" : "Upload Proof Document"}
        open={proofUploadModal}
        onCancel={() => {
          setProofUploadModal(false);
          setProofFile(null);
          setPendingAcceptData(null);
        }}
        footer={null}
      >
        <Row className="header">
          <Col span={24} >
            <Upload
              beforeUpload={() => false}
              onChange={handleProofFileChange}
              fileList={proofFile ? [{
                uid: '-1',
                name: proofFile.name,
                status: 'done',
                originFileObj: proofFile,
              }] : []}
              maxCount={1}
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              onRemove={() => {
                setProofFile(null);
                return true;
              }}
            >
              <Button style={{marginBottom:"10px"}}>Select File</Button>
            </Upload>
            <p className="desc" style={{ marginTop: "10px", marginBottom: 0 }}>
              Please upload a proof document (PDF, DOC, DOCX, JPG, JPEG, or PNG)
            </p>
          </Col>
        </Row>
        <Row align={"middle"} gutter={16} justify={"end"}>
          <Col>
            <Button
              className="cancelBtn"
              onClick={() => {
                setProofUploadModal(false);
                setProofFile(null);
                setPendingAcceptData(null);
              }}
            >
              Cancel
            </Button>
          </Col>
          <Col>
            <Button
              className="confirmBtn"
              loading={uploadingProof}
              onClick={handleProofUpload}
            >
              {pendingAcceptData?.isApproved === "rejected" ? "Upload & Reject" : "Upload & Accept"}
            </Button>
          </Col>
        </Row>
      </Modal>
      {/* <BulkDelete
        selectedCandidates={selectedCandidates}
        BulkDeleteModal={BulkDeleteModal}
        setBulkDeleteModal={setBulkDeleteModal}
      /> */}
      <DeleteModal
        visible={bulkDeleteModal}
        setVisible={setBulkDeleteModal}
        text={"Candidate(s)"}
        handleSubmit={handleDeleteSubmit}
        loading={deleteLoading}
      />
      <StatusModal
        open={statusModal}
        setOpen={setStatusModal}
        candidateSelectedData={
          selectedRowData?.length > 0 ? selectedRowData[0] : {}
        }
        selectedRowData={selectedRowData}
        onSubmit={updateBulkCandidateJobStatus}
      />
      <Reportpopup
        data={{
          ...candidateSelectedData,
          candidateName: candidateSelectedData?.profileId?.name || candidateSelectedData?.candidateName || ""
        }}
        reportModal={reportModal}
        setReportModal={setReportModal}
      />
      <UpdatestatusPopup
        updatePopup={updatePopup}
        setUpdatePopUp={setUpdatePopup}
        setUpdatePopup={setUpdatePopup}
        candidateSelectedData={candidateSelectedData}
        onSubmit={updateCandidateJobStatus}
      />
      <DeleteAdvertModal
        visible={activeDeleteModal}
        setVisible={setActiveDeleteModal}
        text={"Advert"}
        handleSubmit={deleteAdvert}
        loading={deleteLoading}
      />
      <ReleaseModal
        visible={releaseModal}
        setVisible={setreleaseModal}
        text={"release"}
        handleSubmitAssign={bulkassign}
        loading={deleteLoading}
      />

      <IncomingWorkforceRequestsModal
        visible={incomingWorkforceVisible && hasSelected}
        onClose={() => setIncomingWorkforceVisible(false)}
        advertId={id}
        applicationIds={selectedRowKeys}
        onTransferSuccess={() => {
          getCandidateDetails();
        }}
      />

      <TransferUserModal
        isModalOpen={transferUserModal}
        handleCancel={() => setTransferUserModal(false)}
        handleOk={async (data) => {
          try {
            // Get candidateId from the selected candidate data
            const candidateId = 
              candidateSelectedData?._id 
             

            if (!candidateId) {
              message.error("Candidate ID not found.");
              return;
            }

            const payload = {
              candidateId: candidateId,
              recipientUserIds: data.recipientUserIds || [],
              recipientEmails: data.recipientEmails || [],
            };

            if (payload.recipientUserIds.length === 0 && payload.recipientEmails.length === 0) {
              message.warning("Please select at least one user or add an email.");
              return;
            }

            const response = await API_MANAGER.forwardProfile(payload);
            message.success("Profile successfully forwarded.");
            setTransferUserModal(false);
            // Refresh candidate details if needed
            getCandidateDetails();
          } catch (error) {
            message.error(
              error?.response?.data?.message ||
                "Failed to forward profile. Please try again."
            );
          }
        }}
        candidateSelectedData={candidateSelectedData}
      />
      <TransferModal
        transferModal={transferModal}
        setTransferModal={setTransferModal}
        candidateSelectedData={candidateSelectedData}
        oldAdvertId={oldAdvertId}
        profileId={profileId}
        candidateName={candidateName}
        setReloadState={setReloadState}
        transferData={transferData}
        search={advertSearch}
        setSearch={setAdvertSearch}
        setfilterDataAdvert={setfilterDataAdvert}
        setadvertIds={setadvertIds}
      />
      <DeleteUserPopup
        isModalOpen={isModalOpen}
        setisModalOpen={setisModalOpen}
      />

      <UpdateAlert updateAlert={updateAlert} setUpdateAlert={setUpdateAlert} />
      <div className="advert_detail_container">
        <Row>
          <Col xs={24} md={0}>
            <MobileHeader title={"Advert Details"} />
          </Col>
        </Row>
        <div className="advert_detail_box">
          <Row align={"middle"} justify={"space-between"}>
            <Col xs={16} md={20}>
              <Row align={"middle"}>
                <Col className="name">{advertDetail?.jobTitle?.name}</Col>
              </Row>
            </Col>
            <Col className="gap-12" xs={7} md={3}>
              <div className="w-100">
                {userType !== "Associate" && (
                  <div className="advert-header-actions">
                    <Tooltip title="Clone advert" placement="top">
                      <img
                        src={CloneIcon}
                        className="cursor_pointer"
                        alt="clone advert"
                        onClick={handleCloneAdvert}
                      />
                    </Tooltip>
                    <img
                      src={EditIcon}
                      className="cursor_pointer"
                      alt="edit"
                      onClick={() =>
                        navigate(`/create-advert?id=${advertDetail?.id}`, {
                          state: advertDetail,
                        })
                      }
                    />
                    <img
                      src={deleteIcon}
                      className="cursor_pointer"
                      alt="delete"
                      onClick={() => setActiveDeleteModal(true)}
                    />
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <div className="detail_row">
            <Row gutter={16} justify={"space-between"}>
              <Col xs={12} md={6}>
                <p className="title">Location</p>
                <p className="detail">
                  {advertDetail?.suburb}, {advertDetail?.state?.name},{" "}
                  {advertDetail?.postalCode}
                </p>
              </Col>
              <Col xs={12} md={4}>
                <p className="title  align-text-end-sm">Salary/Rate</p>
                <p className="detail align-text-end-sm">
                  {advertDetail?.minSalary &&
                  advertDetail?.maxSalary &&
                  advertDetail?.minSalary !== advertDetail?.maxSalary
                    ? `$${
                        advertDetail?.minSalary
                          ? numberWithCommas(
                              advertDetail?.minSalary?.toString()?.includes(".")
                                ? parseFloat(advertDetail?.minSalary)?.toFixed(
                                    2
                                  )
                                : advertDetail?.minSalary
                            )
                          : 0
                      }-$${
                        advertDetail?.maxSalary
                          ? numberWithCommas(
                              advertDetail?.maxSalary?.toString()?.includes(".")
                                ? parseFloat(advertDetail?.maxSalary)?.toFixed(
                                    2
                                  )
                                : advertDetail?.maxSalary
                            )
                          : 0
                      }`
                    : `$${
                        advertDetail?.minSalary
                          ? numberWithCommas(
                              advertDetail?.minSalary?.toString()?.includes(".")
                                ? parseFloat(advertDetail?.minSalary)?.toFixed(
                                    2
                                  )
                                : advertDetail?.minSalary
                            )
                          : 0
                      }`}
                </p>
              </Col>
              <Col xs={12} md={6}>
                <p className="title">Start Date</p>
                <p className="detail">
                  {moment(advertDetail?.startDate).format("DD MMM YYYY")}
                </p>
              </Col>
              <Col xs={12} md={4}>
                <p className="title align-text-end-sm">End Date</p>
                <p className="detail align-text-end-sm">
                  {moment(advertDetail?.endDate).format("DD MMM YYYY")}
                </p>
              </Col>
            </Row>
          </div>
        </div>
        <div>
          <AdvertSummary advertDetail={advertDetail} />
        </div>
        {candidateDetails?.result?.length > 0 || search ? (
          <div className="advert_summary_box">
            <div className="advert_table_box ">
              <Table
                rowSelection={rowSelection}
                columns={columns}
                dataSource={candidateDetails?.result}
                pagination={false}
                scroll={{ x: "calc(750px + 60%)" }}
                loading={loading}
                rowKey={"_id"}
                title={() => (
                  <>
                    <Row className="justify_space">
                      {/* table title part 1 */}
                      <Col xs={0} md={12}>
                        <Row
                          justify={"start"}
                          align="middle"
                          gutter={{ lg: 20, xl: 32 }}
                          style={{ gap: "12px" }}
                        >
                          {userType !== "Associate" && (
                            <Col
                              className="align_items_center"
                            style={{cursor:"pointer"}}
                              onClick={
                                selectedRowKeys?.length > 0
                                  ? handleDelete
                                  : null
                              }
                            >
                              <Tooltip title="Remove">
                                <Row align={"middle"} gutter={4}>
                                  <Col style={{ marginTop: "4px" }}>
                                    <CommonDeleteSvg
                                      color={hasSelected ? "#D03C28" : "#A7AEBB"}
                                    />
                                  </Col>
                                 
                                </Row>
                              </Tooltip>
                            </Col>
                          )}
                          {userType !== "Associate" && (
                            <Col
                              className="align_items_center"
                                style={{cursor:"pointer"}}
                              onClick={
                                selectedRowKeys?.length > 0
                                  ? handleStatusButton
                                  : null
                              }
                            >
                              <Tooltip title="Status">
                                <Row align={"middle"} gutter={8}>
                                  <Col style={{ marginTop: "4px" }}>
                                    <TableStatusImage
                                      color={hasSelected ? "#1638B1" : "#A7AEBB"}
                                    />
                                  </Col>
                                  
                                </Row>
                              </Tooltip>
                            </Col>
                          )}

                          {subscription &&
                            subscription?.sp?.active &&
                            JSON.parse(
                              localStorage.getItem("isPlusSubscription")
                            ) && (
                              <Col
                                // span={11}
                                className="candidate_report_col cursor_pointer"
                                // onClick={() => handleUpdagradeMembership()}
                                onClick={() => candidateReport()}
                              >
                                <Tooltip title="Generate Candidate Report">
                                  <Row align={"middle"} gutter={4}>
                                    <Col>
                                      <img src={downloadIcon} />
                                    </Col>
                                    
                                  </Row>
                                </Tooltip>
                              </Col>
                            )}
                          <Col
                            // span={11}
                            className="candidate_report_col cursor_pointer"
                            // onClick={() => handleUpdagradeMembership()}
                            onClick={ehHrReport}
                          >
                            <Tooltip title="Export">
                              <Row align={"middle"} gutter={4}>
                                <Col>
                                  <img src={exportImage} />
                                </Col>
                                
                              </Row>
                            </Tooltip>
                          </Col>
                           {userType !== "Associate" && (
                            <Col
                              className="candidate_report_col cursor_pointer"
                              onClick={handleReleaseClick}
                            >
                              <Tooltip title="Share with 3rd party platforms">
                                <Row align="middle" gutter={4}>
                                  <Col>
                                    <img src={externalRocket} height={26} width={40}/>
                                  </Col>
                                 
                                </Row>
                              </Tooltip>
                            </Col>
                          )}

                          <ReleaseToExternalClientModal
                            visible={modalVisible}
                            onClose={handleModalClose}
                            onNext={handleNextStep}
                            candidateDetails={candidateDetails?.result}
                          />
                          {userType !== "Associate" && (
                            <Col
                            
                              // span={11}
                              className="candidate_report_col cursor_pointer"
                              // onClick={() => handleUpdagradeMembership()}

                              onClick={
                                selectedRowKeys?.length > 0
                                  ? handelAssign
                                  : null
                              }
                            >
                              
                              <Row align={"middle"} gutter={4}>
                                <Col>
                                <Tooltip title="Release to Client">
                                  <img
                                    src={rocketIcon}
                                    style={{
                                      opacity: hasSelected ? 1 : 0.4,
                                      cursor: hasSelected
                                        ? "pointer"
                                        : "not-allowed",
                                    }}
                                  />
                                   </Tooltip>
                                </Col>
                                <Col>
                                 
                                </Col>
                              </Row>
                            </Col>
                          )}
                          {userType !== "Associate" && (
                            <Col
                              className="candidate_report_col cursor_pointer workforce-transfer-action align_items_center"
                              onClick={
                                hasSelected ? handleIncomingWorkforceOpen : null
                              }
                            >
                              <Tooltip
                                title={
                                  !hasSelected
                                    ? "Select candidate(s) first"
                                    : !allSelectedHaveHardReview()
                                    ? "Select a candidate who has reached Hard Review"
                                    : "Workforce transfer request"
                                }
                              >
                                <Row
                                  align={"middle"}
                                  gutter={4}
                                  className="workforce-transfer-action-row"
                                >
                                  <Col>
                                    <WorkforceTransferToolbarIcon
                                      ready={
                                        hasSelected && allSelectedHaveHardReview()
                                      }
                                    />
                                  </Col>
                                </Row>
                              </Tooltip>
                            </Col>
                          )}
                        </Row>
                      </Col>

                      {/* table titile part2  */}
                      <Col xs={24} md={12}>
                        <Row gutter={16} className="w-100" justify={"end"}>
                          <Col xs={24} md={16} className="sm-w100 sm-flex">
                            <Input.Search
                              className="searchBox sm-w100"
                              placeholder="Search candidate name"
                              prefix={<img src={SearchIcon} alt="search" />}
                              onChange={(e) => {
                                const newSearchValue = e?.target?.value;
                                const isClearing = !newSearchValue && search;
                                const isNewSearch = newSearchValue && !search;
                                
                                if (isNewSearch) {
                                  pageBeforeSearchRef.current = currentPage;
                                  setCurrentPage(1);
                                } else if (isClearing && pageBeforeSearchRef.current !== null) {
                                  setCurrentPage(pageBeforeSearchRef.current);
                                  pageBeforeSearchRef.current = null;
                                } else if (newSearchValue) {
                                  if (pageBeforeSearchRef.current === null) {
                                    pageBeforeSearchRef.current = currentPage;
                                  }
                                  setCurrentPage(1);
                                }
                                
                                setSearch(newSearchValue);
                              }}
                              value={search}
                              suffix={
                                search && (
                                  <img
                                    src={CancelIcon}
                                    className="cursor_pointer"
                                    alt="cross"
                                    onClick={() => {
                                      const pageToRestore = pageBeforeSearchRef.current !== null 
                                        ? pageBeforeSearchRef.current 
                                        : 1;
                                      setSearch("");
                                      setCurrentPage(pageToRestore);
                                      pageBeforeSearchRef.current = null;
                                    }}
                                  />
                                )
                              }
                            />
                            <div>
                              <Dropdown
                                menu={{
                                  items: tableHeaderPop,
                                }}
                                overlayClassName="notificationFilterDropdown"
                              >
                                <img
                                  className="dp-none-md advert-vertical-dots "
                                  src={verticleDot}
                                  alt="vertical dots"
                                />
                              </Dropdown>
                            </div>
                          </Col>
                          <Col xs={0} md={8} className="dp-none-sm">
                            <Button
                              className="btn"
                              onClick={() =>
                                // navigate(`/advert-tracker/${advertDetail?.id}`)
                                handleTrackerClick()
                              }
                            >
                              Tracker
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                )}
                // onRow={(record, rowIndex) => {
                //   return {
                //     onClick: (event) => {
                //       navigate(
                //         `/applicant-profile/${record?.profileId?.userId?._id}`,
                //         {
                //           state: {
                //             id: id,
                //           },
                //         }
                //       );
                //     }, // click row
                //     style: { cursor: "pointer" },
                //   };
                // }}
              />

              <CustomPagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                total={candidateDetails?.totalCount}
                itemPerPage={10}
              />
            </div>
            <Row className="w-100 mt-20">
              <Col xs={24} md={0}>
                <Button
                  className="btn_sm w-100"
                  onClick={() => handleTrackerClick()}
                >
                  Tracker
                </Button>
              </Col>
            </Row>
          </div>
        ) : (
          <NoElementBox title="Nobody applied yet!" />
        )}

        {/* <JobActiveDeactivateModal
          visible={jobModal}
          setVisible={setJobModal}
          active={jobActive}
        /> */}
      </div>
    </SubLayout>
  );
}

export default AdvertDetail;